module.exports = __webpack_public_path__ + "img/trend-down.d0e7754f.svg";